
const AUSTRALIAN_STATES = [
  'New South Wales', 'Victoria', 'Queensland', 'Western Australia',
  'South Australia', 'Tasmania', 'Australian Capital Territory', 'Northern Territory'
];

// Corresponds to the SORT_ORDER_MAP in your backend
const SORT_OPTIONS = {
  "date": "Most Recent",
  "title": "Title (A-Z)",
  "headline": "Headline First",
  "fullJob": "Full Job First",
};

// Corresponds to the selectedFilters array in your backend
const TOGGLE_FILTERS = {
  // "noSalesLeads": "No Sales Leads",
  // "salesLeads": "Has Sales Leads",
  // "processed": "Processed By Manila",
  // "noCatholicJobs": "No Catholic Jobs",
};

const JobSearchFilters = ({ params, onFilterChange }) => {

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    // Rebuild the filter1 array based on the new selection
    const newFilter1 = [...params.filter1.filter(f => f.category !== "State")];
    if (selectedState) {
      newFilter1.push({ category: "State", filter: selectedState });
    }
    onFilterChange({ filter1: newFilter1 });
  };
  
  const handleToggleFilterChange = (e) => {
    const { name, checked } = e.target;
    const currentFilters = params.selectedFilters || [];
    let newSelectedFilters;

    if (checked) {
      newSelectedFilters = [...currentFilters, name];
    } else {
      newSelectedFilters = currentFilters.filter(filter => filter !== name);
    }
    onFilterChange({ selectedFilters: newSelectedFilters });
  };

  // Find the current state filter value for the dropdown
  const currentState = params.filter1.find(f => f.category === "State")?.filter || '';

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm mb-6 border border-gray-200">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">

        {/* Sort Order */}
        <div>
          <label htmlFor="sort-order" className="block text-sm font-medium text-gray-700">
            Sort By
          </label>
          <select
            id="sort-order"
            value={params.sort}
            onChange={(e) => onFilterChange({ sort: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          >
            {Object.entries(SORT_OPTIONS).map(([key, value]) => (
              <option key={key} value={key}>{value}</option>
            ))}
          </select>
        </div>

        {/* State Filter */}
        <div>
          <label htmlFor="state-filter" className="block text-sm font-medium text-gray-700">
            Filter by State
          </label>
          <select
            id="state-filter"
            value={currentState}
            onChange={handleStateChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          >
            <option value="">All Australian States</option>
            {AUSTRALIAN_STATES.map((state) => (
              <option key={state} value={state}>{state}</option>
            ))}
          </select>
        </div>
        
        {/* Toggle Filters */}
        <div className="">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Additional Filters
          </label>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {Object.entries(TOGGLE_FILTERS).map(([key, label]) => (
                <div key={key} className="flex items-center">
                    <input
                        id={key}
                        name={key}
                        type="checkbox"
                        checked={params.selectedFilters?.includes(key)}
                        onChange={handleToggleFilterChange}
                        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    />
                    <label htmlFor={key} className="ml-2 block text-sm text-gray-900">
                        {label}
                    </label>
                </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobSearchFilters;